module.exports = __webpack_public_path__ + "img/modalRecapSvg2024-es.5e91c25c.svg";